module.exports = __webpack_public_path__ + "img/ai_remove_logo2.f34aadf8.jpg";